<template>
  <base-overlay :show="fetchingData">
    <div>
      <NewGateModal
        @gate-set="setQueuedGate"
        @gate-removed="removeQueuedGate"
      />
      <validation-observer ref="formRef">
        <b-card>
          <b-row>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-group
                  label="Name"
                  label-for="closed-zone-name"
                >
                  <b-form-input
                    id="closed-zone-name"
                    v-model="zoneData.name"
                    placeholder="Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="City"
                rules="required"
              >
                <b-form-group
                  label="City"
                  label-for="closed-zone-city"
                >
                  <b-form-input
                    id="closed-zone-city"
                    v-model="zoneData.city"
                    placeholder="City"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Parent"
                label-for="closed-zone-parent"
              >
                <v-select
                  id="closed-zone-parent"
                  v-model="zoneData.closedAreaDetails.parent"
                  placeholder="Select Parent Zone"
                  :options="zonesOptions"
                  label="name"
                  :clearable="false"
                  :reduce="val => val.value"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Status"
                rules="required"
              >
                <b-form-group
                  label="Status"
                  label-for="closed-zone-status"
                >
                  <b-form-radio-group
                    id="closed-zone-status"
                    v-model="zoneData.status"
                    :options="statusOptions"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4" />
            <b-col md="4">
              <b-button
                variant="primary"
                block
                :disabled="submittingZone"
                @click="submitZone"
              >
                <b-spinner
                  v-if="submittingZone"
                  small
                />
                <span v-else>Save</span>
              </b-button>
            </b-col>
            <b-col md="12">
              <div id="closed-zone-map" />
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </div>
  </base-overlay>
</template>

<script>
/* eslint-disable no-undef */
import vSelect from 'vue-select'
import {
  onMounted, ref, shallowRef, computed, onUnmounted,
} from '@vue/composition-api'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormRadioGroup, BCard, BButton, BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import zoneStoreModule from '../../zoneStoreModule'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import NewGateModal from './NewGateModal.vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    vSelect,
    BaseOverlay,
    BCol,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BSpinner,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BCard,
    NewGateModal,
  },
  setup(_, ctx) {
    function isMarkerInsidePolygon(marker, poly) {
      const polyPoints = poly.getPath().getArray().map(e => ({
        lat: e.lat(),
        lng: e.lng(),
      }))
      const x = marker.latitude; const
        y = marker.longitude

      let inside = false
      // eslint-disable-next-line no-plusplus
      for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
        const xi = polyPoints[i].lat; const
          yi = polyPoints[i].lng
        const xj = polyPoints[j].lat; const
          yj = polyPoints[j].lng

        const intersect = ((yi > y) !== (yj > y))
            // eslint-disable-next-line no-mixed-operators
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
        if (intersect) inside = !inside
      }

      return inside
    }
    const zoneData = ref({
      city: '',
      area: 'None',
      name: '',
      status: 'INACTIVE',
      country: 'Jordan',
      closedAreaDetails: {
        parent: '',
        pickupLocations: [],
      },
      polygon: [],
    })
    useRegisterStoreModule('zones', zoneStoreModule)

    const statusOptions = [
      { text: 'Active', value: 'ACTIVE' },
      { text: 'Inactive', value: 'INACTIVE' },
    ]
    const zonesOptions = ref([])
    const fetchZones = async () => {
      const res = await ctx.root.$store.dispatch('zones/fetchZones')
      zonesOptions.value = res.filter(z => !z.closedAreaDetails).map(z => ({
        ...z,
        value: `${z.country}::${z.city}`,
      }))
    }

    const queuedGate = ref({
      label: {
        en: '',
        ar: '',
      },
      formattedAddress: {
        en: '',
        ar: '',
      },
      latitude: null,
      longitude: null,
    })
    const paths = ref([])
    const polygon = shallowRef()
    const map = shallowRef(null)
    const initMap = async () => {
      // eslint-disable-next-line no-undef
      map.value = new google.maps.Map(document.getElementById('closed-zone-map'), {
        zoom: 10,
        center: { lat: 31.963158, lng: 35.930359 },
      })
      map.value.setOptions({
        draggableCursor: 'crosshair',
      })
      // eslint-disable-next-line no-undef
      polygon.value = new google.maps.Polygon({
        paths: paths.value,
        editable: true,
      })
      // polygon.value.addListener('mouseup', e => {
      //   console.log(zoneData.value.closedAreaDetails.pickupLocations, 'MARKERS')
      //   console.log('HA?', e)
      //   if (zoneData.value.closedAreaDetails.pickupLocations.length) {

      //   }
      // })
      polygon.value.setMap(map.value)

      polygon.value.addListener('click', e => {
        const markerPosition = e.latLng.toJSON()
        queuedGate.value.latitude = markerPosition.lat
        queuedGate.value.longitude = markerPosition.lng
        ctx.root.$bvModal.show('zone-new-gate-modal')
      })
      map.value.addListener('click', e => {
        paths.value.push(e.latLng.toJSON())
        polygon.value.setPaths(paths.value)
      })
    }
    const createNewMarker = gateData => {
      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: {
          lat: gateData.latitude,
          lng: gateData.longitude,
        },
        map: map.value,
      })

      const contentString = `<div style="display:flex;flex-direction:column">
            <h5>Label En: ${gateData.label.en}</h5>
            <h5>Label Ar: ${gateData.label.ar}</h5>
            <h5>Address En: ${gateData.formattedAddress.en}</h5>
            <h5>Address Ar: ${gateData.formattedAddress.ar}</h5>
            <button
            id="remove-gate-${gateData.id}"
            style="background: #CE224D;
              border: 0;
              padding: 5px 8px;
              border-radius: 5px;
              color: white;
              width:100%"
            >Remove Gate</button>
        </div>`
      // eslint-disable-next-line no-undef
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      })
      marker.addListener('click', () => {
        infowindow.open({
          anchor: marker,
          map: map.value,
        })
      })
      google.maps.event.addListener(infowindow, 'domready', () => {
        const removeGateButton = document.getElementById(`remove-gate-${gateData.id}`)
        if (removeGateButton) {
          removeGateButton.addEventListener('click', () => {
            const gateIx = zoneData.value.closedAreaDetails.pickupLocations.findIndex(l => l.id === gateData.id)
            zoneData.value.closedAreaDetails.pickupLocations.splice(gateIx, 1)
            marker.setMap(null)
          })
        }
      })
      return marker
    }
    const removeQueuedGate = () => {
      queuedGate.value.latitude = null
      queuedGate.value.longitude = null
      ctx.root.$bvModal.hide('zone-new-gate-modal')
    }

    const setQueuedGate = gateData => {
      const tempGateData = JSON.parse(JSON.stringify(gateData))
      const temp = {
        latitude: queuedGate.value.latitude,
        longitude: queuedGate.value.longitude,
        ...tempGateData,
        id: Math.random().toString(),
      }
      zoneData.value.closedAreaDetails.pickupLocations.push(temp)
      createNewMarker(temp)
      removeQueuedGate()
    }

    const submittingZone = ref(false)
    const submitZone = async () => {
      const { formRef } = ctx.refs
      const valid = await formRef.validate()
      if (!valid) return
      const cityFound = zonesOptions.value.find(z => z.city.toLowerCase() === zoneData.value.city.toLowerCase())
      if (cityFound) {
        errorNotification('City already exists')
        return
      }
      if (!zoneData.value.closedAreaDetails.parent) {
        errorNotification('Parent is a required field')
        return
      }
      if (!paths.value.length) {
        errorNotification('You did not draw any polygon')
        return
      }
      if (!zoneData.value.closedAreaDetails.pickupLocations.length) {
        errorNotification('At least one gate required in the polygon')
        return
      }
      const allGatesInsidePolygon = zoneData.value.closedAreaDetails.pickupLocations.every(loc => isMarkerInsidePolygon({
        latitude: loc.latitude,
        longitude: loc.longitude,
      }, polygon.value))

      if (!allGatesInsidePolygon) {
        errorNotification('Make sure all gates are inside the polygon')
        return
      }
      zoneData.value.polygon = []
      polygon.value.getPath().forEach(e => {
        zoneData.value.polygon.push({
          lat: e.lat(),
          lng: e.lng(),
        })
      })
      const firstPolygonCoordinate = JSON.stringify(zoneData.value.polygon[0])
      const lastPolygonCoordinate = JSON.stringify(zoneData.value.polygon[zoneData.value.polygon.length - 1])
      if (firstPolygonCoordinate !== lastPolygonCoordinate) {
        zoneData.value.polygon.push(zoneData.value.polygon[0])
      }
      try {
        submittingZone.value = true
        await ctx.root.$store.dispatch('zones/putZone', zoneData.value)
        ctx.root.$router.push('/zones-services')
        successNotification('Closed zone created successfully')
      } finally {
        submittingZone.value = false
      }
    }
    const fetchingData = ref(false)
    const zoneInfo = computed(() => ctx.root.$store.getters['zones/selectedZone'])
    onMounted(async () => {
      try {
        fetchingData.value = true
        await fetchZones()
        if (zoneInfo.value) {
          paths.value = zoneInfo.value.polygon
          console.log('Zone infooo', zoneInfo.value)
          zoneData.value.name = zoneInfo.value.name
          zoneData.value.city = zoneInfo.value.city
          zoneData.value.status = zoneInfo.value.status
          zoneData.value.closedAreaDetails.parent = zoneInfo.value.closedAreaDetails.parent
          zoneData.value.closedAreaDetails.pickupLocations = zoneInfo.value.closedAreaDetails.pickupLocations
          initMap()
          const bounds = new google.maps.LatLngBounds()
          paths.value.forEach(p => {
            bounds.extend(
              new google.maps.LatLng(
                p.lat,
                p.lng,
              ),
            )
          })
          map.value.fitBounds(bounds)
          zoneInfo.value.closedAreaDetails.pickupLocations.forEach(loc => {
            createNewMarker(loc)
          })
        } else {
          initMap()
        }
      } finally {
        fetchingData.value = false
      }
    })
    onUnmounted(() => {
      console.log('Unmount')
      ctx.root.$store.dispatch('zones/selectZone', null)
    })
    return {
      submittingZone,
      required,
      zonesOptions,
      fetchingData,
      removeQueuedGate,
      setQueuedGate,
      zoneData,
      submitZone,
      statusOptions,
    }
  },
}
</script>

<style scoped>
#closed-zone-map {
  width: 100%;
  height: 500px;
}
</style>
